import styled, { css, DefaultTheme } from 'styled-components'
import media from 'styled-media-query'

export const ContainerMenu = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: ${theme.grid.container};
    margin-left: auto;
    margin-right: auto;
    padding-left: calc(${theme.grid.gutter} / 2);
    padding-right: calc(${theme.grid.gutter} / 2);
    background: transparent;
  `}
`
export const Wrapper = styled.menu`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding: 1rem 0;
    position: relative;
    z-index: ${theme.layers.menu};
    background-color: ${theme.colors.white};
    border-bottom: 2px solid ${theme.colors.border};
    justify-content: end;
  `}
`

export const MenuGroup = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
    align-items: center;
    #notification-btn {
      all: unset;
      position: relative;
      margin: 0 10px;
      cursor: pointer;
      &.ativo {
        &::before {
          content: attr(data-notification-count);
          position: absolute;
          width: 1.5rem;
          height: 1.5rem;
          display: grid;
          place-items: center;
          color: white;
          font-weight: 600;
          font-size: 12px;
          border-radius: 999px;
          background-color: ${theme.colors.orange};
          top: 0;
          right: 0;
          z-index: 1;
        }
      }
    }
  `}
`
export const MenuNav = styled.div`
  ${({ theme }) => css`
    /* margin-left: ${theme.spacings.small}; */
  `}
`

const linkModifiers = {
  default: (theme: DefaultTheme) => css`
    color: ${theme.colors.gray};
    font-family: ${theme.font.family};
    &:hover {
      color: ${theme.colors.gray};
    }
  `,
  active: (theme: DefaultTheme) => css`
    color: ${theme.colors.black};
    font-weight: 700;
    &:hover {
      color: ${theme.colors.black};
    }
    &::after {
      content: '';
      position: absolute;
      display: block;
      height: 4px;
      width: 100%;
      top: 4.7rem;
      left: 0;
      background-color: ${theme.colors.borderMenu};
      ${media.lessThan('large')`
          display:none;
        `}
    }
  `
}
type LinkProps = {
  isActive?: boolean
}
export const MenuLink = styled.a<LinkProps>`
  ${({ theme, isActive }) => css`
    position: relative;
    font-family: ${theme.font.family};
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    margin: 0.3rem ${theme.spacings.small} 0;
    text-decoration: none;
    text-align: center;
    transition: color, ${theme.transition.default};

    ${!isActive && linkModifiers.default(theme)}
    ${isActive && linkModifiers.active(theme)}

    ${media.between('large', 'huge')`
      margin: 0.3rem 1.2rem 0;
    `}
  `}
`

export const BotaoVoltar = styled.button`
  background-color: transparent;
  border: none;
`
